<template>
    <span class="monospaced text-right">
        <b-badge v-if="distance.value > 8" variant="success">{{ distance.formatted }}</b-badge>
        <b-badge v-else-if="distance.value > 2" variant="secondary">{{ distance.formatted }}</b-badge>
        <b-badge v-else-if="distance.value >= 0" variant="warning">{{ distance.formatted }}</b-badge>
        <b-badge v-else variant="danger">{{ distance.formatted }}</b-badge>
    </span>    
</template>

<script>
import formatter from '@/mixins/formatter';

export default {
    name: 'PriceDistance',
    mixins: [formatter],
    props: ['openPrice', 'currentPrice'],
    computed: {
        distance() {
            return this.getDistance(this.openPrice, this.currentPrice);
        },
    }
}

</script>


<style>
.monospaced { 
    font-family: var(--font-family-monospace);
}
</style>